import React, { FC } from "react";
import { StyledLogo } from "./style";
import logo from "../../../assets/images/logo/logo.png";
import { Image } from "../../UI/Image";
const Logo: FC = () => {
  return (
    <StyledLogo path="/">
      <Image src={logo} alt="Responsive Images" size="sm" fit="cover" />
    </StyledLogo>
  );
};

export default Logo;
